<template>
  <div class="app-container">
    <div class="header">
      <span class="header-text">广 西 标 准 化 协 会 标 准 业 务 系 统</span>
    </div>
    <div class="content">
      <el-tabs type="card" stretch @tab-click="changeTab">
        <el-tab-pane>
          <span slot="label"><i class="el-icon-reading"></i> 证书</span>
          <div class="content-one">
            <div class="check">
              <span>
                <el-select v-model="selectIndexCertificate" placeholder="请选择" class="select">
                  <el-option
                    v-for="item in optionsCertificate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <span>
                <el-input v-model="inputContentCertificate" placeholder="请输入关键字，若不输入关键字，则检索全部记录"
                          class="input"></el-input>
              </span>
              <span>
                <el-button @click="selectCertificateClick">检索</el-button>
              </span>
            </div>
            <div class="table">
              <el-table v-loading="loading" :data="certificateList" border height="505">
                <el-table-column label="姓名" align="center" prop="name"/>
                <el-table-column label="单位名称" align="center" prop="unitName"/>
                <el-table-column label="证书编号" align="center" prop="certificateNumber"/>
                <el-table-column label="是否签字" align="center" prop="ifSignature">
                  <template slot-scope="scope">
                    <span>{{ scope.row.ifSignature == 'Y' ? '是' : '否' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark"/>
              </el-table>
            </div>
            <div class="pg">
              <pagination
                v-show="totalCertificate>0"
                :total="totalCertificate"
                :page.sync="queryParamsCertificate.pageNum"
                :limit.sync="queryParamsCertificate.pageSize"
                @pagination="selectCertificateClick"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-edit"></i> 团体标准制定</span>
          <div class="content-one">
            <div class="check">
              <span>
                <el-select v-model="selectIndexFormulate" placeholder="请选择" class="select">
                  <el-option
                    v-for="item in optionsFormulate"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <span>
                <el-input v-model="inputContentFormulate" placeholder="请输入关键字，若不输入关键字，则检索全部记录"
                          class="input"></el-input>
              </span>
              <span>
                <el-button @click="selectFormulateClick">检索</el-button>
              </span>
            </div>
            <div class="table">
              <el-table v-loading="loading" :data="formulateList" border height="505">
                <el-table-column label="立项编号" align="center" prop="projectNumber"/>
                <el-table-column label="团体标准名称" align="center" prop="groupStandardName"/>
                <el-table-column label="团体标准性质" align="center" prop="groupStandardProperty"/>
                <el-table-column label="制定或修订" align="center" prop="formulateOrRevise"/>
                <el-table-column label="起止时间" align="center" prop="startStopTime"/>
                <el-table-column label="采用国际标准或国外先进标准" align="center" prop="adoptionStandard"/>
                <el-table-column label="团体标准提出单位" align="center" prop="proposedUnit"/>
                <el-table-column label="起草单位" align="center" prop="draftUnit"/>
                <el-table-column label="备注" align="center" prop="remark"/>
              </el-table>
            </div>
            <div class="pg">
              <pagination
                v-show="totalFormulate>0"
                :total="totalFormulate"
                :page.sync="queryParamsFormulate.pageNum"
                :limit.sync="queryParamsFormulate.pageSize"
                @pagination="selectFormulateClick"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-upload2"></i> 团体标准发布</span>
          <div class="content-one">
            <div class="check">
              <span>
                <el-select v-model="selectIndexPublish" placeholder="请选择" class="select">
                  <el-option
                    v-for="item in optionsPublish"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <span>
                <el-input v-model="inputContentPublish" placeholder="请输入关键字，若不输入关键字，则检索全部记录"
                          class="input"></el-input>
              </span>
              <span>
                <el-button @click="selectPublishClick">检索</el-button>
              </span>
            </div>
            <div class="table">
              <el-table v-loading="loading" :data="publishList" border height="505">
                <el-table-column label="团体标准编号" align="center" prop="groupStandardMark"/>
                <el-table-column label="团体标准名称" align="center" prop="groupStandardName"/>
                <el-table-column label="发布日期" align="center" prop="publishTime" width="180">
                  <template slot-scope="scope">
                    <span>{{ parseTime(scope.row.publishTime, '{y}-{m}-{d}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="实施日期" align="center" prop="implementTime" width="180">
                  <template slot-scope="scope">
                    <span>{{ parseTime(scope.row.implementTime, '{y}-{m}-{d}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark"/>
              </el-table>
            </div>
            <div class="pg">
              <pagination
                v-show="totalPublish>0"
                :total="totalPublish"
                :page.sync="queryParamsPublish.pageNum"
                :limit.sync="queryParamsPublish.pageSize"
                @pagination="selectPublishClick"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-s-unfold"></i> 地方标准汇总</span>
          <div class="content-one">
            <div class="check">
              <span>
                <el-select v-model="selectIndexPlace" placeholder="请选择" class="select">
                  <el-option
                    v-for="item in optionsPlace"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <span>
                <el-input v-model="inputContentPlace" placeholder="请输入关键字，若不输入关键字，则检索全部记录"
                          class="input"></el-input>
              </span>
              <span>
                <el-button @click="selectPlaceClick">检索</el-button>
              </span>
            </div>
            <div class="table">
              <el-table v-loading="loading" :data="placeList" border height="505">
                <el-table-column label="地方标准类型" align="center" prop="placeStandardType"/>
                <el-table-column label="地方标准代号" align="center" prop="placeStandardMark"/>
                <el-table-column label="地方标准名称" align="center" prop="placeStandardName"/>
                <el-table-column label="发布日期" align="center" prop="publishTime" width="180">
                  <template slot-scope="scope">
                    <span>{{ parseTime(scope.row.publishTime, '{y}-{m}-{d}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="实施日期" align="center" prop="implementTime" width="180">
                  <template slot-scope="scope">
                    <span>{{ parseTime(scope.row.implementTime, '{y}-{m}-{d}') }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="地方提出单位" align="center" prop="proposedUnit"/>
                <el-table-column label="起草单位" align="center" prop="draftUnit"/>
                <el-table-column label="备注" align="center" prop="remark"/>
              </el-table>
            </div>
            <div class="pg">
              <pagination
                v-show="totalPlace>0"
                :total="totalPlace"
                :page.sync="queryParamsPlace.pageNum"
                :limit.sync="queryParamsPlace.pageSize"
                @pagination="selectPlaceClick"
              />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane>
          <span slot="label"><i class="el-icon-document"></i> 标准立项清单</span>
          <div class="content-one">
            <div class="check">
              <span>
                <el-select v-model="selectIndexList" placeholder="请选择" class="select">
                  <el-option
                    v-for="item in optionsList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </span>
              <span>
                <el-input v-model="inputContentList" placeholder="请输入关键字，若不输入关键字，则检索全部记录"
                          class="input"></el-input>
              </span>
              <span>
                <el-button @click="selectListClick">检索</el-button>
              </span>
            </div>
            <div class="table">
              <el-table v-loading="loading" :data="listList" border height="505">
                <el-table-column label="标准类型" align="center" prop="standardType"/>
                <el-table-column label="立项编号" align="center" prop="projectNumber"/>
                <el-table-column label="标准项目名称" align="center" prop="projectName"/>
                <el-table-column label="标准性质" align="center" prop="standardProperty"/>
                <el-table-column label="制定或修订" align="center" prop="formulateOrRevise"/>
                <el-table-column label="起止年限" align="center" prop="startStopTime"/>
                <el-table-column label="采用国际标准或国外先进标准" align="center" prop="adoptionStandard"/>
                <el-table-column label="地方提出单位" align="center" prop="proposedUnit"/>
                <el-table-column label="起草单位" align="center" prop="draftUnit"/>
                <el-table-column label="备注" align="center" prop="remark"/>
              </el-table>
            </div>
            <div class="pg">
              <pagination
                v-show="totalList>0"
                :total="totalList"
                :page.sync="queryParamsList.pageNum"
                :limit.sync="queryParamsList.pageSize"
                @pagination="selectListClick"
              />
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="footer">
      <span class="footer-text">Copyright©2019 广西标准化协会 All Rights Reserved. 桂ICP备20000817号-1 公安备案号:45010302002149</span>
    </div>
  </div>
</template>

<script>
import {listCertificate, listFormulate, listList, listPublish, listStandard} from "../api/api";
import {parseTime} from "../utils/ruoyi";

export default {
  name: "StandardList",
  data() {
    return {
      loading: false,
      /****************************证书************************/
      // 下拉列表属性
      optionsCertificate: [
        {
          value: 'name',
          label: '姓名'
        },
        {
          value: 'unitName',
          label: '单位名称'
        },
        {
          value: 'certificateNumber',
          label: '证书编号'
        }
      ],
      // 查询参数
      queryParamsCertificate: {
        pageNum: 1,
        pageSize: 10
      },
      // 选中的选项
      selectIndexCertificate: 'name',
      // 输入的查询关键字
      inputContentCertificate: '',
      certificateList: [],
      // 总条数
      totalCertificate: 0,
      /*******************************团体标准制定*******************************/
      optionsFormulate: [
        {
          value: 'projectNumber',
          label: '立项编号'
        },
        {
          value: 'groupStandardName',
          label: '标准名称'
        },
        {
          value: 'groupStandardProperty',
          label: '标准性质'
        },
        {
          value: 'formulateOrRevise',
          label: '制定或修订'
        },
        {
          value: 'startStopTime',
          label: '起止时间'
        },
        {
          value: 'adoptionStandard',
          label: '采用国际标准'
        },
        {
          value: 'proposedUnit',
          label: '提出单位'
        },
        {
          value: 'draftUnit',
          label: '起草单位'
        }
      ],
      // 查询参数
      queryParamsFormulate: {
        pageNum: 1,
        pageSize: 10
      },
      // 选中的选项
      selectIndexFormulate: 'projectNumber',
      // 输入的查询关键字
      inputContentFormulate: '',
      formulateList: [],
      // 总条数
      totalFormulate: 0,
      /*********************************团体标准发布*********************************/
      optionsPublish: [
        {
          value: 'groupStandardMark',
          label: '团体标准编号'
        },
        {
          value: 'groupStandardName',
          label: '团体标准名称'
        },
        {
          value: 'publishTime',
          label: '发布日期'
        },
        {
          value: 'implementTime',
          label: '实施日期'
        }
      ],
      // 查询参数
      queryParamsPublish: {
        pageNum: 1,
        pageSize: 10
      },
      // 选中的选项
      selectIndexPublish: 'groupStandardMark',
      // 输入的查询关键字
      inputContentPublish: '',
      publishList: [],
      // 总条数
      totalPublish: 0,
      /*******************************地方标准汇总***********************************/
      optionsPlace: [
        {
          value: 'placeStandardType',
          label: '地方标准类型'
        },
        {
          value: 'placeStandardMark',
          label: '地方标准代号'
        },
        {
          value: 'placeStandardName',
          label: '地方标准名称'
        },
        {
          value: 'publishTime',
          label: '发布日期'
        },
        {
          value: 'implementTime',
          label: '实施日期'
        },
        {
          value: 'proposedUnit',
          label: '提出单位'
        },
        {
          value: 'draftUnit',
          label: '起草单位'
        }
      ],
      // 查询参数
      queryParamsPlace: {
        pageNum: 1,
        pageSize: 10
      },
      // 选中的选项
      selectIndexPlace: 'placeStandardType',
      // 输入的查询关键字
      inputContentPlace: '',
      placeList: [],
      // 总条数
      totalPlace: 0,
      /********************************标准立项清单*******************************/
      optionsList: [
        {
          value: 'standardType',
          label: '标准类型'
        },
        {
          value: 'projectNumber',
          label: '立项编号'
        },
        {
          value: 'projectName',
          label: '标准项目名称'
        },
        {
          value: 'standardProperty',
          label: '标准性质'
        },
        {
          value: 'formulateOrRevise',
          label: '制定或修订'
        },
        {
          value: 'startStopTime',
          label: '起止年限'
        },
        {
          value: 'adoptionStandard',
          label: '采用国际标准'
        },
        {
          value: 'proposedUnit',
          label: '提出单位'
        },
        {
          value: 'draftUnit',
          label: '起草单位'
        }
      ],
      // 查询参数
      queryParamsList: {
        pageNum: 1,
        pageSize: 10
      },
      // 选中的选项
      selectIndexList: 'standardType',
      // 输入的查询关键字
      inputContentList: '',
      listList: [],
      // 总条数
      totalList: 0,
    }
  },
  created() {
    this.selectCertificateClick()
  },
  methods: {
    parseTime,
    changeTab(event) {
      switch (event.index) {
        case '0':
          this.selectCertificateClick()
          break
        case '1':
          this.selectFormulateClick()
          break
        case '2':
          this.selectPublishClick()
          break
        case '3':
          this.selectPlaceClick()
          break
        case '4':
          this.selectListClick()
          break
      }
    },
    selectCertificateClick() {
      this.loading = true;
      this.queryParamsCertificate[this.selectIndexCertificate] = this.inputContentCertificate;
      listCertificate(this.queryParamsCertificate).then((res) => {
        this.certificateList = res.data.rows;
        this.totalCertificate = res.data.total;
        this.loading = false;
        this.$message({
          message: '记录检索成功！',
          type: 'success'
        });
        // 检索成功之后清空查询参数
        delete this.queryParamsCertificate[this.selectIndexCertificate]
      })
    },
    selectFormulateClick() {
      this.loading = true;
      this.queryParamsFormulate[this.selectIndexFormulate] = this.inputContentFormulate;
      listFormulate(this.queryParamsFormulate).then((res) => {
        this.formulateList = res.data.rows;
        this.totalFormulate = res.data.total;
        this.loading = false;
        this.$message({
          message: '记录检索成功！',
          type: 'success'
        });
        // 检索成功之后清空查询参数
        delete this.queryParamsFormulate[this.selectIndexFormulate]
      })
    },
    selectPublishClick() {
      this.loading = true;
      this.queryParamsPublish[this.selectIndexPublish] = this.inputContentPublish;
      listPublish(this.queryParamsPublish).then((res) => {
        this.publishList = res.data.rows;
        this.totalPublish = res.data.total;
        this.loading = false;
        this.$message({
          message: '记录检索成功！',
          type: 'success'
        });
        // 检索成功之后清空查询参数
        delete this.queryParamsPublish[this.selectIndexPublish]
      })
    },
    selectPlaceClick() {
      this.loading = true;
      this.queryParamsPlace[this.selectIndexPlace] = this.inputContentPlace;
      listStandard(this.queryParamsPlace).then((res) => {
        this.placeList = res.data.rows;
        this.totalPlace = res.data.total;
        this.loading = false;
        this.$message({
          message: '记录检索成功！',
          type: 'success'
        });
        // 检索成功之后清空查询参数
        delete this.queryParamsPlace[this.selectIndexPlace]
      })
    },
    selectListClick() {
      this.loading = true;
      this.queryParamsList[this.selectIndexList] = this.inputContentList;
      listList(this.queryParamsList).then((res) => {
        this.listList = res.data.rows;
        this.totalList = res.data.total;
        this.loading = false;
        this.$message({
          message: '记录检索成功！',
          type: 'success'
        });
        // 检索成功之后清空查询参数
        delete this.queryParamsList[this.selectIndexList]
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  margin: 0 auto;
}

.header {
  width: 100%;
  height: 120px;
  background: url("../assets/header.jpg") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  line-height: 120px;
}

.header-text {
  color: white;
  font-size: 35px;
}

.check {
  text-align: center;
}

.select {
  width: 150px;
}

.input {
  width: 550px;
}

.content {
  width: 65%;
  height: 730px;
  border: 1px solid #E4E7ED;
  border-radius: 5px;
  margin: 5px auto 0;
}

.table {
  margin-top: 15px;
}

.pg {
  text-align: center;
}

.footer {
  width: 65%;
  background: #eceef1;
  height: 50px;
  margin: 5px auto 0;
  border-radius: 5px;
  text-align: center;
  line-height: 50px;
}

.footer-text {
  color: #5b5c5e;
  font-size: 13px;
}

@media screen and (max-width: 600px) {
  .header {
    width: 100%;
    height: 100px;
    background: url("../assets/header.jpg") no-repeat;
    background-size: cover;
    text-align: center;
    line-height: 100px;
  }

  .header-text {
    color: white;
    font-size: 20px;
  }

  .input {
    width: 200px;
  }

  .content {
    width: 100%;
    height: 730px;
    border: 1px solid #E4E7ED;
    border-radius: 5px;
    margin: 5px auto 0;
  }

  .pg {
    text-align: center;
    height: 80px;
  }

  .footer {
    width: 100%;
    background: #eceef1;
    height: 50px;
    margin: 5px auto 0;
    border-radius: 5px;
    display: none;
  }

  .footer-text {
    color: #5b5c5e;
    font-size: 10px;
    overflow-wrap: break-word;
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/StandardList.vue